import { Carriers } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import { FulfillmentOrderAddressSchema } from "@redotech/redo-model/fulfillments/fulfillment-order-address";
import { z } from "zod";

export const getOriginAddresses = {
  input: z.object({ carrier: z.nativeEnum(Carriers), clientDate: z.date() }),
  output: z.object({ addresses: z.array(FulfillmentOrderAddressSchema) }),
};
